/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import isArray from 'lodash/isArray';
import styles from './index.styl';
import Hint from '../common/Hint';

const defaultDescriptionRenderer = description =>
  isArray(description) ? description.join(', ') : description;

const DefinitionList = ({
  className,
  definition,
  description,
  hideEllipsis,
  multiline,
  hintText,
  descriptionRenderer = defaultDescriptionRenderer,
  hasOpacity,
  formatMessage,
}) => (
  <dl
    {...{ className }}
    styleName={classNames('root', {
      'root--multiline': multiline,
      hideEllipsis,
    })}
  >
    <dt
      children={
        <div>
          {definition} {hintText && <Hint hintText={hintText} />}
        </div>
      }
      styleName="definition"
    />
    <dd
      children={descriptionRenderer(description, formatMessage)}
      styleName="description"
    />
  </dl>
);

DefinitionList.propTypes = {
  className: PropTypes.string,
  definition: PropTypes.string,
  hintText: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.string,
    PropTypes.object,
  ]),
  multiline: PropTypes.bool,
  descriptionRenderer: PropTypes.func,
  hasOpacity: PropTypes.bool,
  hideEllipsis: PropTypes.bool,
  formatMessage: PropTypes.func,
};

DefinitionList.defaultProps = { multiline: false, hasOpacity: true };

export default CSSModules(DefinitionList, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/DefinitionList/index.jsx